// Классификатор HTTP-статуса ответа стрима уведомлений.
//
// Правило — по семейству статуса, а не по конкретному коду:
// - 401/403 — отказ авторизации: токен невалиден, повтор бесполезен,
//   но это не «стрим недоступен» — редирект на логин сделает
//   следующий authedFetch, поэтому индикатор здесь не нужен.
// - Прочие 4xx (в т.ч. 404, 400, 405, 410, 422) — терминальный отказ:
//   сервер жив и отвечает, что запрос в таком виде не выполнится;
//   повтор того же запроса ничего не изменит до передеплоя. Разница
//   с 401/403 в том, что это не про личность запрашивающего — стрим
//   в принципе недоступен, и это нужно показать оператору.
// - Исключение из правила 4xx — 408 и 429: они протокольно означают
//   «повтори позже» (timeout / rate limit), а не «этот путь не
//   существует», поэтому остаются `retryable`.
// - 5xx и всё, что меньше 400 (включая успешные 2xx/3xx, а заодно и
//   любой не-HTTP `status` вроде `0` или отрицательного) — временный
//   либо не-ошибочный случай: ретраим как раньше.
// - `NaN` — единственный вход, который не попадает ни в одно
//   числовое сравнение (любое сравнение с `NaN` ложно), поэтому
//   разбирается отдельной веткой в начале. Безопаснее ретраить, чем
//   объявлять стрим мёртвым: `permanent` означает «сервер явно
//   сказал, что так не заработает», а `NaN` не говорит вообще ничего.
//
// Функция тотальная: принимает любой статус, включая `200` — вызывать
// её нужно до проверки `response.ok`, чтобы терминальные 4xx не
// проваливались в общую ветку `!response.ok`.

export type StreamOutcome = "authFailed" | "permanent" | "retryable";

const HTTP_UNAUTHORIZED = 401;
const HTTP_FORBIDDEN = 403;
const HTTP_REQUEST_TIMEOUT = 408;
const HTTP_TOO_MANY_REQUESTS = 429;
const HTTP_CLIENT_ERROR_MIN = 400;
const HTTP_SERVER_ERROR_MIN = 500;

export function classifyStreamOutcome(status: number): StreamOutcome {
  if (Number.isNaN(status)) {
    return "retryable";
  }
  if (status === HTTP_UNAUTHORIZED || status === HTTP_FORBIDDEN) {
    return "authFailed";
  }
  if (status < HTTP_CLIENT_ERROR_MIN || status >= HTTP_SERVER_ERROR_MIN) {
    return "retryable";
  }
  if (status === HTTP_REQUEST_TIMEOUT || status === HTTP_TOO_MANY_REQUESTS) {
    return "retryable";
  }
  return "permanent";
}
